export const isDisablePaymentObject = (name: string, isSearchPolicy: boolean) => {
  if (name === 'premium_NB') return false
  return !isSearchPolicy
}
